import { Button } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import SelectCreditCard from 'v2/components/Shared/SelectCreditCard';
import { ShoppingPaymentStatusId } from 'v2/interfaces/shopping';
import { customerFactory } from 'v2/services/customer';
import shoppingService from 'v2/services/shopping/subscription';

import type { ICard } from 'v2/components/Shared/SelectCreditCard';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';

interface ChangePaymentMethodProps {
  delivery: ShoppingDelivery;
  closeQuickView: (refetch?: boolean) => void;
}

export const ChangePaymentMethod = ({ delivery, closeQuickView }: ChangePaymentMethodProps) => {
  const [open, setOpen] = useState(false);

  useObservable(() => customerFactory.loadCardsListSubscriptions(), []);
  const [cardsList] = useObservable(() => customerFactory.getCardsListSubscriptions(), []);
  const [isLoadingCards] = useObservable(() => customerFactory.loadingCardsSubscriptions(), []);

  const openPaymentMethod = () => setOpen(true);

  const closePaymentMethod = () => setOpen(false);

  const onSelectCard = useCallback(
    (card: ICard) => {
      setOpen(false);
      shoppingService
        .changeSubscriptionPayment(delivery.subscriptionId, card)
        .pipe(tap(() => shoppingService.setPagination({ per_page: 50, current_page: 1 })))
        .subscribe(() => {
          toast.success('Forma de pagamento alterada com sucesso!');
          const shouldRefetchList = true;
          closeQuickView(shouldRefetchList);
        }, toast.error);
    },
    [delivery, closeQuickView]
  );

  if (!!delivery?.product.allowsCard && delivery?.status !== ShoppingPaymentStatusId.CANCELADA) {
    return (
      <>
        <Button color='primary' variant='outlined' onClick={openPaymentMethod} fullWidth>
          Trocar forma de pagamento
        </Button>
        <SelectCreditCard isOpen={open} onClose={closePaymentMethod} onFinish={onSelectCard} cardsList={cardsList} isLoadingCards={isLoadingCards} />
      </>
    );
  }

  return null;
};
